var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","dark":"","height":"2rem","color":"backgroundWhite"},on:{"click":_vm.toggleDarkMode}},[_c('v-icon',{attrs:{"color":"titleLight"}},[_vm._v("\n    "+_vm._s(_vm.isDarkMode ? "mdi-white-balance-sunny" : "mdi-weather-night")+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }